import { FC } from 'react';
import { headerColumns, marketersTableHeaderColumns } from '../../user-management.utils';
import { TableHeaderProps } from './TableHeader.types';

export const TableHeader: FC<TableHeaderProps> = ({ activeTab, onSort, usersHeaderRef, marketersHeaderRef }) => {
  if (activeTab === 'users') {
    return (
      <div className="user-management-table-header-wrapper" ref={usersHeaderRef as any}>
        <div className="users-table-header">
          {headerColumns.map((col, index) => (
            <div
              key={col.key || index}
              className={`um-header-cell ${col.className} ${col.key ? 'sortable' : ''}`}
              onClick={() => col.key && onSort(col.key)}
            >
              {col.label}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="user-management-table-header-wrapper" ref={marketersHeaderRef as any}>
      <div className="marketers-table-header">
        {marketersTableHeaderColumns.map(col => (
          <div key={col.key} className={`um-header-cell ${col.className}`}>
            {col.label}
          </div>
        ))}
      </div>
    </div>
  );
};
